import { MetaCache } from "@pdfking/compatibility"
import { Partial } from "@pdfking/tfunc"

const store = MetaCache<any>("Persistence")

export default <T>(
  key: string
): { get: () => Promise<T | undefined>; set: (value: T) => Promise<void> } => {
  return {
    get: Partial(store.get, key),
    set: Partial(store.set, key),
  }
}
